import { useCallback, useState } from 'react';

type UseLocalNavigationAccordionReturn = {
  isExpanded: (accordionId: string) => boolean;
  toggleAccordion: (accordionId: string) => void;
};

export function useLocalNavigationAccordion(): UseLocalNavigationAccordionReturn {
  const [openAccordionId, setOpenAccordionId] = useState<string | null>(null);

  const toggleAccordion = useCallback((accordionId: string): void => {
    setOpenAccordionId((prev) => (prev === accordionId ? null : accordionId));
  }, []);

  const isExpanded = useCallback(
    (accordionId: string): boolean => {
      return openAccordionId === accordionId;
    },
    [openAccordionId]
  );

  return { isExpanded, toggleAccordion };
}
